module.exports = __webpack_public_path__ + "components/flag/static/square/cn-e2750956d173aa7761be9dba91ff5fa7.svg";